export class SliderImageStyle {
  height: number;

  static normalize(styles: Partial<SliderImageStyle>): SliderImageStyle {
    const pureStyles = new SliderImageStyle();

    pureStyles.height = styles.height ?? pureStyles.height;

    return pureStyles;
  }
}
